import { PayloadAction } from '@reduxjs/toolkit';

import { ELoanUsage, EQuickQuoteFinanceType } from '../types';

export const loanReducers = {
    setLoanUsage: (state, action: PayloadAction<ELoanUsage>): void => {
        state.loan.loanUsage = action.payload;
    },
    setBusinessFinanceType: (state, action: PayloadAction<EQuickQuoteFinanceType>): void => {
        state.loan.businessFinanceType = action.payload;
    },
    setPurchasePrice: (
        state,
        action: PayloadAction<number | undefined>
    ): void => {
        state.loan.purchasePrice = action.payload;
    },
    setTradeIn: (state, action: PayloadAction<number | undefined>): void => {
        state.loan.tradeIn = action.payload;
    },
    setDeposit: (state, action: PayloadAction<number | undefined>): void => {
        state.loan.deposit = action.payload;
    },
    setBalloon: (state, action: PayloadAction<number | undefined>): void => {
        state.loan.balloon = action.payload;
    },
    setLoanTerm: (state, action: PayloadAction<number>): void => {
        state.loan.loanTerm = action.payload;
    },
};
